import KySoModal from "./KySoModal";

export default KySoModal;
